import React,{useState,useEffect,useLayoutEffect,useRef } from 'react';
import { useStore } from "react-redux";
import { Button } from '../components/atoms/button';
import { useHistory } from "react-router-dom";
import { login } from '../reducers/login';
import User from '../User';
import useMedia from "use-media";
import { connect } from "react-redux";
import '../resources/css/login/login.css';
import { golfFacility, golfFacilitySearch, GolfMemberCheck } from '../const';
import common from "../resources/RTCC/js/common/common";
import axios from "axios";

const GolfLoginCheck = (props) => {
    const { 
        setCourse,
        setKaiinken, 
        course,
        kaiinken,
    } = props;
    const history = useHistory();
    const [kaiinkenFlg, setKaiinkenFlg] = useState(false);
    const store = useStore();

    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupRef = useRef(null);

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    //画面読み込み時に1度だけしか実行させない
    useLayoutEffect(() => {
        let state = store.getState().login;
        let memberInfo = null;
        console.log(Object.keys(state).length);
        if(Object.keys(state).length === 0){
            setKaiinkenFlg(true);
            return;
        }
        else{
            memberInfo = state.memberInfo;
        }
        if(memberInfo === null || memberInfo === undefined){
            setKaiinkenFlg(true);
            return;
        }

        popupRef.current.scrollTop = 0;

        // メンバー情報なしの場合
        if(!memberInfo.length){
            setKaiinkenFlg(true);
            return;
        }

        if(kaiinken.length === 0 || kaiinken === undefined || kaiinken === null){
            let count = {count : 0};
            let kaiinkenList = [];
            let selectObjList = [];
            let checkList = [];
            for(let i = 0; i < memberInfo.length;i++){
                const memberList = memberInfo[i].memberList;
                if (memberList === null) {
                    continue;
                } else if (memberList.data === null) {
                    continue;
                }
                const kaiinInfoList = memberList.data.kaiinInfoList;

                if(kaiinInfoList === undefined || kaiinInfoList.length === 0 || kaiinInfoList[0].riyokenKbn !== "0"){
                    continue;
                }

                for(let j=0; j<kaiinInfoList.length; j++){
                    console.log(kaiinInfoList[j]);
                    //ついか(会員権をリストに格納)
                    let selectObj = {};
                    let kaiinSisetuCd;
                    selectObj["id"] = kaiinInfoList[j].ownerNo;
                    selectObj["facility"] = "";
                    selectObj["facilityCd"] = "";
                    selectObj["ownerCd"] = kaiinInfoList[j].ownerCd;
                    selectObj["contractNo"] = kaiinInfoList[j].keiyakuNo;
                    selectObj['kaiinkenSyubetCd'] = kaiinInfoList[j].golfKaiinkenSyubetCd;
                    selectObj["value"] = kaiinInfoList[j].ownerNo+"：";
                    selectObj['kaiinName'] = kaiinInfoList[j].kojinNamKj1;
                    selectObj["selected"] = false;
                    if(kaiinInfoList[j].sisetuCd === '223' || kaiinInfoList[j].sisetuCd === '224'){
                        kaiinSisetuCd = '804';
                    }else{
                        kaiinSisetuCd = kaiinInfoList[j].sisetuCd;
                    }
                    selectObj["sisetuCd"] = kaiinSisetuCd;
                    selectObjList.push(selectObj);
                    let obj = {
                        kaiinKind:kaiinInfoList[j].golfKaiinkenSyubetCd,
                        keiyakuNo:kaiinInfoList[j].ownerCd,
                        sisetuCd:kaiinSisetuCd,
                    }
                    checkList.push(obj);
                    //ここまで
                    if(kaiinInfoList[j].sisetuCd === '223' || kaiinInfoList[j].sisetuCd === '224'){
                        kaiinInfoList[j].sisetuCd = '804';
                    }
                    kaiinkenList.push(kaiinInfoList[j]);
                    let sisetuCd = kaiinInfoList[j].sisetuCd
                    if (sisetuCd === '223' || sisetuCd === '224' ) {
                        sisetuCd = '804';
                    }
                }
            }
            common.doPostRef(GolfMemberCheck, {memberInfoList:checkList},selectObjList ,afterGolfMemberCheck);
        }
    }, []);

    //会員権チェック
    const afterGolfMemberCheck= async (res,ref) => {

        if(ref.length !== 0){
            for(let i = 0; i < ref.length; i++){
                //会員権と施設の紐づけ処理(表示用に施設名が欲しい)
                await axios.post(golfFacilitySearch, {sisetuCd:ref[i].sisetuCd}).then((res) => {
                    if(res.data.length !== 0){
                        ref[i].facility = res.data[0].facility_name;
                        ref[i].facilityCd = res.data[0].courseid;
                        ref[i].value = ref[i].value + res.data[0].facility_name;
                        console.log("refリスト書き込み");
                    }
                })
            }
            console.log("refリスト書き込み終了");
        }else{
            //会員権無し
            console.log("refリスト無し モーダル表示");
            setKaiinkenFlg(true);
            return;
        }

        let kaiinkenList = [];
        let count = 0;
        //使用できる会員権かをAPIでチェックして可能なものだけreduxに詰める
        console.log("ref情報取得");
        console.log(ref);
        if(res.data.result !== undefined && res.data.result.length !== 0){
            for(let i = 0; i < ref.length; i++){
                for(let j = 0; j < res.data.result.length; j++){
                    if(res.data.result[j].checkResult && ref[i].ownerCd === res.data.result[j].keiyakuNo){
                        if(count === 0){
                            ref[i].selected = true;
                        }
                        kaiinkenList.push(ref[i]);
                        count ++;
                        console.log("会員権リストプッシュ");
                    }
                }
            }
        }else{
            console.log("会員権チェックデータ無し モーダル表示");
            setKaiinkenFlg(true);
        }
        if(kaiinkenList.length === 0){
            console.log("会員権リスト無し モーダル表示");
            setKaiinkenFlg(true);
        }else{
            console.log("施設紐づけ処理");
            common.doPostRef(golfFacility, {kaiinKind:kaiinkenList[0].kaiinkenSyubetCd,sisetuCd:kaiinkenList[0].sisetuCd}, kaiinkenList ,afterGetFacility);
            setKaiinken(kaiinkenList);
        }
    };

    const afterGetFacility= (res,ref) => {
        const data = res.data.map((item) => {
            return {
                id: item.courseid,
                facilityCd: item.facility_cd,
                value: item.facility_name,
                category: item.hotel_category_name,
                class: "area_course",
                checked: true,
                zip: item.zip,
                address: item.address,
                sortNum:parseInt(item.inside_category_sort),
                access_car: item.access_car,
                facility_overview_title: item.facility_overview_title,
                facility_overview_detail: item.facility_overview_detail,
                url: item.url,
                image_path: item.image_path,
                memberShipAuth: item.memberShipAuth,
            };
        });
        //表示施設のソート処理
        data.sort(function(first,second){
            if (first.sortNum > second.sortNum){
                return 1;
            }else if (first.sortNum < second.sortNum){
                return -1;
            }else{
                return 0;
            }
        })
        setCourse(data);
        
    };

    //ログアウト処理
    const logoutClick= () => {
        history.push("/reserve/top");
    };
    
    return (
        <div ref={popupRef}>
            {kaiinkenFlg ?
            <div style={isMobilePhone ? style.blackBackSp : style.blackBack}>
                <div style={isMobilePhone ? style.golfKindPopUpBackSp : style.golfKindPopUpBack}>
                    <div style={isMobilePhone ? style.golfKindPopUpContentsDivSP : style.golfKindPopUpContentsDiv}>
                        <div style={isMobilePhone ? style.golfKindPopUpSpaceSP : null}>
                            <div style={isMobilePhone ? {fontSize:'14px'} : {fontSize:'20px', padding: "0px 30px"}}>
                                申し訳ございません。こちらはゴルフ会員権所有者限定のメニューとなります。<br></br>
                                会員権をお持ちの方はひも付け登録をされるか、RTTGアプリ事務局（052-300-8666）までご連絡ください。
                            </div>
                            <div style={{display:'flex',alignItems:'center',justifyContent:'center',marginTop:30}}>
                            <Button 
                                onClick={logoutClick}
                                buttonText={"TOP画面へ"}
                                className="logoutBtn"
                            />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :null
            }
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        course: state.course,
        kaiinken:state.kaiinken,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        }
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfLoginCheck);

const style = {
    blackBack:{
        background:"rgba(0,0,0,0.5)",
        height:"100%",
        width:"100%",
        position:"fixed",
        zIndex:1000
    },
    blackBackSp:{
        background:"rgba(0,0,0,0.5)",
        height:"100%",
        width:"100%",
        position:"fixed",
        zIndex:1000,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
    },
    golfKindPopUpBack:{
        position:'fixed',
        height:"300px",
        width:'500px',
        background:"white",
        top:'0',
        left:'0',
        bottom:'0',
        right:'0',
        margin:'auto'
    },
    golfKindPopUpBackSp:{
        // position:'fixed',
        height:"auto",
        width:'85%',
        background:"white",
        // marginTop: "50%"
        // padding: "30px",
    },
    golfKindPopUpContentsDiv:{
        display:'flex',alignItems:'center',justifyContent:'center',height:'100%'
    },
    golfKindPopUpContentsDivSP:{
        padding:"30px"
    },
    golfKindPopUpSpaceSP:{
        // marginTop: "15%"
    },
}